<div class="professionals-container">
  <div class="professionals-content">

    <!-- ── Header ── -->
    <div class="list-header">
      <h5>List Of Corporates</h5>

      <div class="list-actions">

        <!-- Search -->
        <div class="search-box">
          <div class="input-group">
            <span class="input-group-text bg-transparent" style="border: 0px !important">
              <i class="bi bi-search"></i>
            </span>
            <input
              type="text"
              class="form-control"
              style="padding: 0px !important; border: 0px !important"
              placeholder="Search by firm, contact, email..."
              [(ngModel)]="searchQuery"
              (input)="onSearch()"
              (keyup.enter)="onSearch()">
            <span class="input-group-text bg-transparent clear-btn-wrap"
                  *ngIf="searchQuery"
                  (click)="clearSearch()"
                  style="cursor: pointer;">
              <i class="bi bi-x-circle"></i>
            </span>
          </div>
        </div>

        <!-- Status Filter Dropdown -->
        <!-- <div class="status-filter">
          <div class="input-group custom-dropdown">
            <span class="input-group-text bg-transparent">
              <i class="bi bi-funnel"></i>
            </span>
            <div class="form-control dropdown-trigger"
                 (click)="toggleStatusDropdown()">
              {{ statusFilter || 'All Statuses' }}
              <i class="bi bi-chevron-down dropdown-arrow"></i>
            </div>
            <span class="input-group-text bg-transparent clear-btn-wrap"
                  *ngIf="statusFilter"
                  (click)="clearStatusFilter()"
                  style="cursor: pointer;">
              <i class="bi bi-x-circle"></i>
            </span>
            <div class="cdd-menu" *ngIf="isStatusDropdownOpen">
              <div class="cdd-option"
                   [ngClass]="{'cdd-option-active': statusFilter === ''}"
                   (click)="selectStatus('')">
                <i class="bi bi-check cdd-check"></i> All Statuses
              </div>
              <div class="cdd-option"
                   [ngClass]="{'cdd-option-active': statusFilter === 'active'}"
                   (click)="selectStatus('active')">
                <i class="bi bi-check cdd-check"></i> Active
              </div>
              <div class="cdd-option"
                   [ngClass]="{'cdd-option-active': statusFilter === 'pending'}"
                   (click)="selectStatus('pending')">
                <i class="bi bi-check cdd-check"></i> Pending
              </div>
              <div class="cdd-option"
                   [ngClass]="{'cdd-option-active': statusFilter === 'invited'}"
                   (click)="selectStatus('invited')">
                <i class="bi bi-check cdd-check"></i> Invited
              </div>
            </div>
          </div>
        </div> -->

      </div>
    </div>

    <!-- ── Table ── -->
    <div class="professionals-table" [class.loading]="isLoading"
         *ngIf="!isLoading && dataSource.length > 0">
      <table class="table">
        <thead>
          <tr>
            <th class="thdata sortable-col" scope="col" (click)="sortBy('category')">
              Category <i class="bi sort-icon" [ngClass]="getSortIcon('category')"></i>
            </th>
            <th class="thdata sortable-col" scope="col" (click)="sortBy('name')">
              Name / Firm Name <i class="bi sort-icon" [ngClass]="getSortIcon('name')"></i>
            </th>
            <th class="thdata sortable-col hide-md" scope="col" (click)="sortBy('email')">
              Email <i class="bi sort-icon" [ngClass]="getSortIcon('email')"></i>
            </th>
            <th class="thdata hide-md" scope="col">Phone</th>
            <th class="thdata sortable-col hide-lg" scope="col" (click)="sortBy('account_activation_date')">
              Account Activation Date <i class="bi sort-icon" [ngClass]="getSortIcon('account_activation_date')"></i>
            </th>
            <th class="thdata sortable-col hide-lg" scope="col" (click)="sortBy('sub_start_date')">
              Subscription Start <i class="bi sort-icon" [ngClass]="getSortIcon('sub_start_date')"></i>
            </th>
            <th class="thdata sortable-col hide-lg" scope="col" (click)="sortBy('sub_end_date')">
              Subscription End <i class="bi sort-icon" [ngClass]="getSortIcon('sub_end_date')"></i>
            </th>
            <th class="thdata sortable-col hide-lg" scope="col" (click)="sortBy('last_login')">
              Last Login <i class="bi sort-icon" [ngClass]="getSortIcon('last_login')"></i>
            </th>
            <th class="thdata sortable-col" scope="col" (click)="sortBy('status')">
              Status <i class="bi sort-icon" [ngClass]="getSortIcon('status')"></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let p of getPage()">
            <td>{{ p.category || '-' }}</td>
            <td>
              <div class="firm-name">
                <!-- <span class="firm-avatar">{{ getInitials(p.name) }}</span> -->
                <span>{{ p.name || '-' }}</span>
              </div>
            </td>
            <td class="hide-md email-cell">
              <a *ngIf="p.email" [href]="'mailto:' + p.email" class="email-link">
                {{ p.email }}
              </a>
              <span *ngIf="!p.email">-</span>
            </td>
            <td class="hide-md">{{ p.phone || '-' }}</td>
            <td class="hide-lg">{{ formatDate(p.account_activation_date) }}</td>
            <td class="hide-lg">{{ formatDate(p.sub_start_date) }}</td>
            <td class="hide-lg">{{ formatDate(p.sub_end_date) }}</td>
            <td class="hide-lg">{{ formatDateTime(p.last_login) }}</td>
            <td>
              <span class="status-badge" [ngClass]="getStatusClass(p.status)">
                {{ p.status | titlecase }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- ── Skeleton loader ── -->
    <div *ngIf="isLoading" class="skeleton-wrapper">
      <div class="skeleton-row" *ngFor="let i of [1,2,3,4,5,6,7]">
        <div class="skeleton-cell avatar-cell"></div>
        <div class="skeleton-cell wide"></div>
        <div class="skeleton-cell medium"></div>
        <div class="skeleton-cell wide hide-md"></div>
        <div class="skeleton-cell medium hide-md"></div>
        <div class="skeleton-cell medium hide-lg"></div>
        <div class="skeleton-cell short"></div>
      </div>
    </div>

    <!-- ── No Data ── -->
    <div *ngIf="!isLoading && dataSource.length === 0" class="empty-state">
      <i class="bi bi-person-slash empty-icon"></i>
      <p class="empty-title">
        {{ searchQuery || statusFilter ? 'No Results Found' : 'No DGC Professionals Found' }}
      </p>
      <p class="empty-sub">
        {{ searchQuery || statusFilter ? 'Try adjusting your search or filter.' : 'There are currently no corporate professionals.' }}
      </p>
    </div>

    <!-- ── Pagination ── -->
    <div class="pagination-area" *ngIf="!isLoading && dataSource.length > 0">
      <div class="pagination-info">{{ getPaginationRange() }}</div>
      <nav aria-label="DGC professionals pagination">
        <ul class="pagination mb-0">
          <li class="page-item" [ngClass]="{'disabled': pageIndex === 0}">
            <a class="page-link" href="javascript:void(0)" (click)="goToFirstPage()">
              <i class="bi bi-chevron-double-left biarr"></i>
            </a>
          </li>
          <li class="page-item" [ngClass]="{'disabled': pageIndex === 0}">
            <a class="page-link" href="javascript:void(0)" (click)="goToPrevPage()">
              <i class="bi bi-chevron-left biarr"></i> Previous
            </a>
          </li>
          <li *ngFor="let page of getPageNumbers()" class="page-item"
              [ngClass]="{'active': page === pageIndex + 1}">
            <a class="page-link" href="javascript:void(0)"
               (click)="goToPage(page - 1)">{{ page }}</a>
          </li>
          <li class="page-item" [ngClass]="{'disabled': pageIndex >= getTotalPages() - 1}">
            <a class="page-link" href="javascript:void(0)" (click)="goToNextPage()">
              Next <i class="bi bi-chevron-right biarr"></i>
            </a>
          </li>
          <li class="page-item" [ngClass]="{'disabled': pageIndex >= getTotalPages() - 1}">
            <a class="page-link" href="javascript:void(0)" (click)="goToLastPage()">
              <i class="bi bi-chevron-double-right biarr"></i>
            </a>
          </li>
        </ul>
      </nav>
    </div>

  </div>
</div>

<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-clip-rotate"
  [fullScreen]="true">
</ngx-spinner>